import dateFormat from "dateformat";
import Swal from "sweetalert2";
import { format, utcToZonedTime } from "date-fns-tz";

export const formatInTimeZone = (date, fmt, tz = "UTC-03:00") =>
  format(utcToZonedTime(date, tz), fmt, { timeZone: tz });

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

export const transactionID = (prefix) => {
  const dateNow = new Date();
  prefix = typeof prefix === "undefined" ? "PG2" : prefix;

  return (prefix + dateFormat(dateNow, "yyyymmdhhMMss")).padStart(19, "0");
};

export const clientInfo = () => {
  return JSON.parse(localStorage.getItem("clientInfo"));
};

export const notification = async (
  type,
  message,
  defaultTitle = "Sucesso!"
) => {
  const title = type === "error" ? "Error!" : defaultTitle;
  await Swal.fire({
    title: title,
    text: message,
    type: type,
  });
  return false;
};

export const validCpf = (strCPF) => {
  let Soma;
  let Resto;
  Soma = 0;
  if (strCPF == "00000000000") return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(10, 11))) return false;
  return true;
};

export const validCnpj = (s) => {
  let cnpj = s.replace(/[^\d]+/g, "");

  // Valida a quantidade de caracteres
  if (cnpj.length !== 14) return false;

  // Elimina inválidos com todos os caracteres iguais
  if (/^(\d)\1+$/.test(cnpj)) return false;

  // Cáculo de validação
  let t = cnpj.length - 2,
    d = cnpj.substring(t),
    d1 = parseInt(d.charAt(0)),
    d2 = parseInt(d.charAt(1)),
    calc = (x) => {
      let n = cnpj.substring(0, x),
        y = x - 7,
        s = 0,
        r = 0;

      for (let i = x; i >= 1; i--) {
        s += n.charAt(x - i) * y--;
        if (y < 2) y = 9;
      }

      r = 11 - (s % 11);
      return r > 9 ? 0 : r;
    };

  return calc(t) === d1 && calc(t + 1) === d2;
};

export const formatAmount = (amount) => {
  amount = amount / 100;

  return amount.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
};

export const cleanDocument = (document) => {
  let newDocument = document
    .replaceAll(".", "")
    .replaceAll("-", "")
    .replaceAll("/", "")
    .replaceAll(" ", "");

  return newDocument;
};

export const countDay = (quant) => {
  var dt = new Date();
  dt.setDate(dt.getDate() + quant);
  var mes = dt.getMonth();
  var ano = dt.getFullYear();
  var dia = dt.getDate();
  mes += 1;
  mes = mes <= 9 ? 0 + mes.toString() : mes;
  console.log(ano + "-" + mes + "-" + dia);
  return ano + "-" + mes + "-" + dia;
};

export const parseCentsToBRL = (value) => {
  const moneyFormatter = (Number(value) / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
  return moneyFormatter.normalize("NFKC");
};
